import AbstractChart from './abstract-chart.js';


export default class PieChart extends AbstractChart 
{

	constructor(params) 
	{
		super(params);

		this.params.type = 'pie';
	}
	

	createVisualization() 
	{
		return new google.visualization.PieChart(document.getElementById(this.params.id));
	}

}